import { render } from "./RegenereNewItemsPopover.vue?vue&type=template&id=11f3c974&scoped=true"
import script from "./RegenereNewItemsPopover.vue?vue&type=script&lang=js"
export * from "./RegenereNewItemsPopover.vue?vue&type=script&lang=js"

import "./RegenereNewItemsPopover.vue?vue&type=style&index=0&id=11f3c974&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f3c974"]])

export default __exports__